import React, { useState } from 'react'
import Collapsible from 'react-collapsible';
import { BsChevronDown } from "react-icons/bs";
import Layout from '../shared/components/Layout'
import { termAccordion, termWellcome } from './components/termString'



export default function TermContainer() {
    const [activeKey, setActiveKey] = useState(null)

    const handleTrigger = (v) => {
        if (v === activeKey) {
            setActiveKey(null)
        } else {
            setActiveKey(v)
        }
    }


    return (
        <Layout>
            <div className="term">
                <div className="bg-light">
                    <div className="container py-main pb-0 justify-content-center d-flex">
                        <div className="col-md-9 ">
                            <h1 className="text-center mb-5">TERMS &amp; CONDITIONS FOR BALESIN</h1>
                            <div className='mb-4' dangerouslySetInnerHTML={{ __html: termWellcome.title }} />
                            <div className='mb-5' dangerouslySetInnerHTML={{ __html: termWellcome.content }} />

                        </div>
                    </div>
                </div>

                <div className="bg-white">
                    <div className="container py-5 justify-content-center d-flex">
                        <div className="col-md-9 ">
                            {
                                termAccordion.map((res, i) => (
                                    <Collapsible
                                        open={activeKey === i ? true : false}
                                        className='mb-3'
                                        handleTriggerClick={() => handleTrigger(i)}
                                        key={i}
                                        trigger={
                                            <div className='d-flex justify-content-between border-bottom pe-3'>
                                                <div dangerouslySetInnerHTML={{ __html: res.title }} />

                                                <BsChevronDown style={{
                                                    transform: `rotate(${activeKey === i ? '180deg' : '0'})`,
                                                    transition: '.3s'
                                                }} />

                                            </div>
                                        }
                                    >
                                        <div className='bg-white p-3 mb-3' dangerouslySetInnerHTML={{ __html: res.content }} />
                                    </Collapsible>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
